/* Woollen House - hide the sticky header on scroll down, reveal on scroll up.
   The theme clones #sticky-header into #sticky-header-active on DOM ready and
   shows it once you pass the original header, so we look the element up on each
   tick rather than caching it at load. */
(function () {
  var THRESHOLD = 6;    // ignore sub-pixel / trackpad jitter
  var ARM_AT   = 140;   // never hide while still near the top of the page
  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var ticking = false;

  function header() {
    return document.querySelector('#sticky-header-active.sticky-header-active') ||
           document.querySelector('.sticky-header-active');
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var el = header();
    var diff = y - lastY;

    if (Math.abs(diff) < THRESHOLD) return;

    if (el) {
      if (diff > 0 && y > ARM_AT) {
        el.classList.add('wh-header-hidden');      // scrolling down
      } else {
        el.classList.remove('wh-header-hidden');   // scrolling up
      }
    }
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });

  // never leave it hidden if the page is restored mid-scroll
  window.addEventListener('pageshow', function () {
    var el = header();
    if (el) el.classList.remove('wh-header-hidden');
  });
})();

/* ---------------------------------------------------------------------
   Best Sellers arrow states.
   Figma pairs the arrows: the end-of-track one is muted cream, the live one
   is near-black. Expressing that in CSS lost to this theme's cascade (26KB
   of inline !important + #id rules), so the state is mirrored onto inline
   styles, which nothing can outrank.
   --------------------------------------------------------------------- */
(function () {
  var ACTIVE = { bg: '#171715', fg: '#ffffff' };
  var MUTED  = { bg: '#EFE9DC', fg: '#A99C86' };

  function paint(btn) {
    var s = btn.disabled ? MUTED : ACTIVE;
    btn.style.setProperty('background-color', s.bg, 'important');
    btn.style.setProperty('color', s.fg, 'important');
    btn.style.setProperty('border', '0', 'important');
    btn.style.setProperty('box-shadow', 'none', 'important');
  }

  function sync() {
    var arrows = document.querySelectorAll('.wh-bs-arrow');
    for (var i = 0; i < arrows.length; i++) paint(arrows[i]);
  }

  function init() {
    var arrows = document.querySelectorAll('.wh-bs-arrow');
    if (!arrows.length) return;
    sync();
    // the section toggles .disabled as the track scrolls
    var obs = new MutationObserver(sync);
    for (var i = 0; i < arrows.length; i++) {
      obs.observe(arrows[i], { attributes: true, attributeFilter: ['disabled'] });
      arrows[i].addEventListener('click', function () { setTimeout(sync, 400); });
    }
    var track = document.querySelector('.wh-bs-overflow');
    if (track) track.addEventListener('scroll', function () { setTimeout(sync, 120); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ---------------------------------------------------------------------
   Quick-view button.
   A theme script writes an inline style="... display:flex !important ..."
   onto .quick-view-btn, which outranks every stylesheet rule, so it has to
   be turned off from JS. Re-applied on mutation because the cards are
   re-rendered when a storefront filter is applied.
   --------------------------------------------------------------------- */
(function () {
  var SEL = '.quick-view-btn,.product-thumb-full-quick-view';

  function hideQuickView() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // only touch it when it is actually visible, so setting the style
      // cannot feed the observer in a loop
      if (el.style.display !== 'none') {
        el.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function init() {
    hideQuickView();
    var target = document.querySelector('#collection-template-query') || document.body;
    if (!target) return;
    new MutationObserver(hideQuickView).observe(target, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ====================================================================
   Cart-drawer scroll lock — scrollbar-width compensation
   Added 2026-08-25.

   The CSS lock (html/body.js-drawer-open{overflow-y:hidden}) removes the
   page scrollbar, which widens the layout by its width and makes the page
   behind the drawer visibly jump. scrollbar-gutter:stable cannot fix this
   (the gutter is ignored once overflow is hidden), so measure the bar and
   publish it as --wh-sbw; the stylesheet pads body + the fixed header by
   that much for as long as the drawer is open.
   ==================================================================== */
(function () {
  var root = document.documentElement;
  var OPEN_CLASSES = ['js-drawer-open', 'js-drawer-open-right', 'js-drawer-open-left'];

  function isOpen() {
    for (var i = 0; i < OPEN_CLASSES.length; i++) {
      if (root.classList.contains(OPEN_CLASSES[i])) return true;
      if (document.body.classList.contains(OPEN_CLASSES[i])) return true;
    }
    return false;
  }

  var cached = null;
  function scrollbarWidth() {
    if (cached !== null) return cached;
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;top:-9999px;left:-9999px;width:100px;height:100px;overflow:scroll';
    document.body.appendChild(probe);
    cached = probe.offsetWidth - probe.clientWidth;  // 0 for overlay scrollbars (mobile, macOS)
    document.body.removeChild(probe);
    return cached;
  }

  function sync() {
    // Only compensate when the page actually had a scrollbar to lose.
    var pad = (isOpen() && root.scrollHeight > root.clientHeight) ? scrollbarWidth() : 0;
    root.style.setProperty('--wh-sbw', pad + 'px');
  }

  function init() {
    var mo = new MutationObserver(sync);
    mo.observe(root, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
